<template>
  <div class="etude">
    <div class="etude-bg" @click="close()"></div>
    <div class="etude-window">
      <div class="related-documents" :class="{ loading: loading }">
        <div class="related-documents-content">
          <div
            v-for="doc in active_study.linked_docs"
            :key="doc.study_id"
            class="related-document"
            :class="{ active: active_doc == doc.study_id }"
            @click="load_related_study(doc)"
          >
            <p class="doc-title">{{ doc.document_type.value }}</p>
            <p class="doc-title">{{ doc.publication_date }}</p>
            <div class="fake-text">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
              <div class="loader">
                <icon file="loader" :size="24"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="close-button" @click="close()">
        <icon file="x" :size="32"/>
      </div>

      <div v-if="!loading" class="etude-header">
        <div class="main-title">
          <p class="title">{{ active_study.name }}</p>
          <p
            class="sub-title"
          >{{ active_study.document_type.value }} par {{ active_study.adequation_consultant }}</p>
        </div>
        <div class="actions">
          <div v-if="is_pdf" class="button" @click="view_pdf()">
            <icon file="eye" :size="20"/>Visualiser
          </div>
          <a class="button primary" :href="active_study.url" target="_blank">
            <icon file="download" :size="20"/>Télécharger
          </a>
        </div>
      </div>

      <div v-if="!loading" class="etude-content">
        <div class="row">
          <div class="col two-third">
            <p class="title">Visualisation du document</p>
            <div
              v-if="is_pdf"
              class="viewer"
              :style="{ height: viewer_height + 'px' }"
              ref="viewer"
            >
              <pdf-file v-if="active_study.url != null" :pdf_src="active_study.url"/>
            </div>
            <div v-else>
              <p>
                <i>Prévisualisation du fichier impossible ({{ file_extension }}), veuillez cliquer sur "Télécharger" pour y accéder</i>
              </p>
            </div>
          </div>
          <div class="col one-third">
            <p class="title">Commentaires</p>
            <div class="comments" :style="{ height: viewer_height + 'px' }">
              <div class="scroll-wrap">
                <div class="scroll" v-bar>
                  <div class="scroll-content">
                    <!-- Add a new comment -->
                    <div class="form">
                      <textarea
                        class="input"
                        rows="1"
                        placeholder="Votre commentaire ici..."
                        v-model="new_comment"
                      ></textarea>
                      <div class="buttons">
                        <button class="button" @click="add_comment">Envoyer</button>
                      </div>
                    </div>
                    <!-- end of add a new comment -->

                    <!-- list all existing comments -->
                    <div class="list-comments">
                      <div v-for="comment in comments" :key="comment.id" class="list-comment">
                        <div>
                          <p class="comment-author">
                            Par
                            <strong>{{ comment.author.firstname }} {{ comment.author.lastname }}</strong>
                            le {{ comment.publication_date }}
                            <span style="float:right" v-if="comment.author.user_id == user_profile.user_id" @click="delete_comment(comment)">X</span>
                          </p>
                        </div>
                        <div class="text">{{ comment.text }}</div>
                      </div>
                    </div>
                    <!-- end of list of comments -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PdfFile from "@/components/etude/pdf-file";
const axios = require("axios");
const moment = require("moment");
moment.locale("fr");

export default {
  name: "etude",
  data: function() {
    return {
      loading: false,
      active_doc: 0,
      viewer_height: 0,
      new_comment: "",
      comments: []
    };
  },
  computed: {
    ...mapGetters(["active_study", "projects", "user_profile"]),
    is_pdf() {
      return this.active_study.url && this.active_study.url.indexOf("pdf") > 0;
    },
    file_extension() {
      let result = "";
      if (this.active_study.url) {
        let chunks = this.active_study.url.split(".");
        if (chunks && chunks.length) {
          result = chunks[chunks.length - 1];
        }
      }
      return result;
    }
  },
  watch: {
    active_doc: function() {
      var self = this;
      this.loading = true;
      setTimeout(function() {
        self.loading = false;
      }, 500);
    }
  },
  methods: {
    resize: function() {
      this.viewer_height = window.innerHeight - (160 + 88 + 24 + 16 + 16 + 24);
    },
    close: function() {
      this.$store.dispatch("toggle_active_project", { study: null });
    },
    view_pdf: function() {
      this.$store.dispatch("set_active_pdf", {
        active_pdf: this.active_study.url
      });
    },
    load_related_study(related_study) {
      //  if study already in studies, set it as the active study (as if the user had clicked on it)
      let new_study = _.find(this.projects, {
        study_id: related_study.study_id
      });
      if (new_study && new_study != undefined) {
        this.$store.dispatch("toggle_active_project", { study: new_study });
      } else {
        // otherwise, load it from the study API
        this.$store.dispatch("load_new_study_by_id", {
          study_id: related_study.study_id
        });
      }
    },
    async add_comment() {
      // check comment is not null or empty
      if (!this.new_comment || this.new_comment.length == 0) {
        return;
      }
      // create comment object to push to API
      const comment_obj = {
        text: this.new_comment,
        author: this.user_profile,
        publication_date: moment().format(),
        content_id: this.active_study.study_id
      };
      // POST new comment
      const comment_api = `${
        process.env.VUE_APP_ES_BASE_URL
      }/cdc_habitat_comments/_doc`;
      try {
        const response = await axios.post(comment_api, comment_obj);
        comment_obj.id = response.data._id;
        comment_obj.publication_date = moment(comment_obj.publication_date).format("LLL");
        // insert latest comment at the beginning of this.comments
        this.add_first_comment(comment_obj);
        this.new_comment = "";
      } catch (error) {
        console.error(error);
      }
    },
    async list_comments() {
      const comment_api = `${
        process.env.VUE_APP_ES_BASE_URL
      }/cdc_habitat_comments/_search?default_operator=AND&size=100&q=content_id:${
        this.active_study.study_id
      }&sort=publication_date:desc`;
      try {
        const response = await axios.get(comment_api);
        this.comments = _.map(response.data.hits.hits, hit => {
          let comment = hit._source;
          comment.id = hit._id;
          comment.publication_date = moment(comment.publication_date).format("LLL");
          return comment;
        });
        console.log("list comments", this.comments);
      } catch (error) {
        console.error(error);
      }
    },
    add_first_comment(comment_obj) {
      this.comments.splice(0, 0, comment_obj);
    },
    async delete_comment(comment) {
      const comment_api = `${
        process.env.VUE_APP_ES_BASE_URL
      }/cdc_habitat_comments/_doc/${comment.id}`;
      try {
        const response = await axios.delete(comment_api);
        this.comments = _.reject(this.comments, ['id', comment.id]);
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted: function() {
    var self = this;
    this.list_comments();

    window.onresize = function(event) {
      self.resize();
    };
    this.resize();
  },
  components: { PdfFile }
};
</script>

<style lang="stylus">
@import '../assets/css/app';

.etude {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: 0.25s easeOutQuart;
  z-index: 10000;

  .etude-bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .etude-window {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 960px;
    background: #fff;
    box-shadow: 0 -4px 8px alpha(#333, 50%);

    .title {
      font-weight: 500;
      font-size: 1.5rem;
      line-height: 16px;
      // text-transform uppercase
    }

    .related-documents {
      height: 160px;
      padding: 24px;
      background: #eee;
      border-bottom: 1px solid #ddd;

      &.loading {
        .related-documents-content {
          .related-document {
            &.active {
              .fake-text {
                .line {
                  opacity: 0.5;
                }

                .loader {
                  display: block;
                }
              }
            }
          }
        }
      }

      .related-documents-content {
        .related-document {
          float: left;
          margin: 0 16px 0 0;
          height: 160px - 48px;
          width: 88px;
          padding: 8px;
          background: #fff;
          border: 2px solid transparent;
          box-shadow: 0 0 4px #999;
          border-radius: radius;
          font-size: 1rem;
          line-height: 14px;
          font-weight: 500;
          cursor: pointer;

          &:hover {
            box-shadow: 0 0 8px #999;
          }

          &.active {
            background-color: lighten(red, 90%);
            box-shadow: 0 0 4px lighten(red, 50%);

            .fake-text {
              .line {
                background-color: lighten(red, 75%);
              }
            }
          }

          &.active {
            border-color: red;

            &:before, &:after {
              content: '';
              position: absolute;
              left: 50%;
              bottom: -(24px + 2);
              margin-left: -12px;
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 0 12px 12px 12px;
              border-color: transparent transparent #fff transparent;
            }

            &:before {
              transform: translateY(-1px);
              border-color: transparent transparent #ccc transparent;
            }
          }

          .fake-text {
            margin: 8px 0 0 0;

            .line {
              height: 6px;
              margin: 0 0 4px 0;
              background: #ddd;

              &:nth-child(1) {
                width: 40%;
              }

              &:nth-child(2) {
                width: 95%;
              }

              &:nth-child(3) {
                width: 75%;
              }

              &:nth-child(4) {
                width: 85%;
              }

              &:nth-child(5) {
                width: 70%;
              }

              &:nth-child(6) {
                width: 90%;
              }
            }

            .loader {
              display: none;
              position: absolute;
              left: 50%;
              top: 50%;
              margin: -12px 0 0 -12px;
              color: red;
              animation: rotate 1s infinite linear;
            }
          }
        }
      }
    }

    .close-button {
      position: absolute;
      right: 8px;
      top: 8px;
      cursor: pointer;
      color: #666;

      &:hover {
        color: red;
      }
    }

    .etude-header {
      height: 88px;
      padding: 24px;

      .main-title {
        .title {
          font-size: 1.9rem;
          line-height: 24px;
        }

        .sub-title {
          line-height: 16px;
        }
      }

      .actions {
        position: absolute;
        right: 24px;
        top: 24px;

        .button {
          display: inline-block;
          margin: 0 0 0 8px;
          height: 40px;
          padding: 0 16px;
          border-radius: radius;
          cursor: pointer;
          background-color: #ddd;
          color: #666;
          font-weight: 500;
          font-size: 1.5rem;
          line-height: @height;
          transition: background-color 0.2s easeOutQuart;
          text-decoration: none;

          &:hover {
            background-color: darken(#ddd, 5%);
          }

          &:active {
            background-color: darken(#ddd, 10%);
          }

          &.primary {
            background-color: red;
            color: #fff;

            &:hover {
              background-color: darken(red, 10%);
            }

            &:active {
              background-color: darken(red, 20%);
            }
          }

          &:hover {
            text-decoration: none;
          }

          &:active {
            transform: translateY(1px);
          }

          .icon {
            float: left;
            margin: 10px 8px 0 0;
          }
        }
      }
    }

    .etude-content {
      padding: 24px;

      .viewer {
        margin: 16px 0 0 0;
        height: 600px;
      }

      .comments {
        margin: 16px 0 0 0;

        .form {
          .input {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
            height: 40px;
            min-height: 64px;
            padding: 12px;
            border: none;
            background-color: #eee;
            border-radius: radius;
            font: inherit;
            color: inherit;
            resize: none;
            outline: none;
          }

          .buttons {
            display: block;
            margin: 8px 0 0 0;
            text-align: right;

            .button {
              display: inline-block;
              height: 32px;
              padding: 0 16px;
              border-radius: radius;
              border: none;
              outline: none;
              background-color: green;
              cursor: pointer;
              font: inherit;
              color: #fff;
              font-size: 1.4rem;
              font-weight: 500;
            }
          }
        }

        .list-comments {
          .list-comment {
            padding: 16px 0;
            border-bottom: 1px dotted #ddd;

            &:last-child {
              border: none;
            }

            .comment-author {
              margin: 0 0 4px 0;
              color: #999;
              font-size: 1.2rem;
              line-height: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
